import React, { Component } from "react";
import AuthService from "../services/AuthService";
import '../css/BisharatMain.css';
import Login from "./Login";
import translate from '../languages/translate';

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
      whatRole : '',
      showReqButton : false,
      successful: false,
      havepermissions: false,
      message: ""
    };
  }
  

  componentDidMount() {
  this.refreshProfile();
}

refreshProfile = () => {
    const loggedInUser = AuthService.getCurrentUser();
    const whatRole = AuthService.getUserRole();
    this.setState({whatRole : whatRole})
    if(loggedInUser) {
    AuthService.isRequestToJoinBish(loggedInUser.username)
    .then(res => {
        const requestedToJoin = res.data;
                if(whatRole === 'BISH' || whatRole === 'ADMIN' || whatRole === 'MODERATOR' ) {
                  this.setState({
                    havepermissions : true
                  });
                } else {
                  if(!requestedToJoin && whatRole === 'USER') {
                    this.setState({showReqButton : true
                    });
                  } 
  
                  else {
                    this.setState({
                      showReqButton : false
                    });
                  }   
                }
              })
            }  
    }


requestAuths(username) {
  const loggedInUser = AuthService.getCurrentUser();
  if(loggedInUser.numberOfSendSMS > 3) {
    
    this.setState({
      locked:true,
      successful: false,
      message: translate("too-much-tries")
    });
  } else {
  AuthService.reqToJoinNow(username)
  .then((response) => {
    localStorage.setItem("verifytry", "5");
      window.location.href = `/activateSMS/${username}`; 
       this.setState({
        successful:true,
        message:""});
  },
    error => {
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      resMessage === "SMS exceed for user" ?  
      this.setState({
        successful: false,
        message: translate("too-much-tries")
      }) : 
      this.setState({
        successful: false,
        message: resMessage
      });

    
    }
  )}
}



resetPassword(username) {
  window.location.href = `/users/${username}/changepassword`;
}


modifyPhone(username) {
  const loggedInUser = AuthService.getCurrentUser();
  if(loggedInUser.numberOfSendSMS > 3) {
    
    this.setState({
      successful: false,
      message: translate("too-much-tries")
    });
  } else {
  window.location.href = `/users/${username}/modifyphone`;
}}
  

  render() {

    const loggedInUser = AuthService.getCurrentUser();
    console.log("Log:",loggedInUser);
    return (
      <div>
      { !loggedInUser ? 
      <div>
        <Login></Login>
      </div> :      
      <div className="viewMain">
        <div className="view-details">
          <div className="card-details">

            {/* <div className="card-group-field">
            <h4> {translate("username")}   </h4>
             <h4> {loggedInUser.username}</h4>   
            </div> */}

             <div className="card-group-field">
            <h4>  {translate("email")}     </h4>
             <h4>{loggedInUser.email}</h4>   
            </div>


            <div className="card-group-field">
            <h4> {translate("password")} </h4>
             <h4> <button className="btn-reset" onClick={() => this.resetPassword(loggedInUser.username)}> {translate("changepassword")}   </button></h4>   
            </div>

            {/* <div className="card-group-field">
            <h4> {translate("permissions")}   </h4>
             <h4>{this.state.whatRole}</h4>   
            </div> */}

            {/* <div className="card-group-field">
            <h4> {translate("phone-num")}   </h4>
            <h4>{loggedInUser.phoneNumber}</h4> 
            <h4> <button className="btn-reset" onClick={() => this.modifyPhone(loggedInUser.username)}> {translate("modifyphone")}   </button></h4>   
            </div> */}

            {/* <a href="/users/resetpassword" className="btn"> تغيير كلمة المرور </a> */}
            {/* <a href="/users/editprofile" className="btn"> تعديل الملف الشخصي  </a> */}
            {/* {!this.state.havepermissions ? 
                 this.state.showReqButton ?
                 <>
                    <p className="par-register">{translate("checkphone")}</p>
                 <p className="par-register">{translate("sendsms")} </p>
                  <button onClick={() => this.requestAuths(loggedInUser.username)} className="btn">{translate("request-family-permissions")}  </button> </>  :
                  <>
                  <p className="alertDanger" >{translate("check-sms-req")} </p>
                  <p className="alertDanger"> {translate("for-more-contact")}    </p> <a href="/contact-us" className="btn">{translate("contact-us")}  </a>
                  </>
                  : <></>
                  }        */}

            <button className="btn" onClick={this.props.history.goBack}> {translate("back")} </button>
            {this.state.successful ? <></> : <p className="alertDanger">  {this.state.message} </p>}
               
          </div>
         
        </div>
      </div>
  }
   </div>
    );
    
}
 
}